// Plaquinhas.js — os selos que aparecem ao lado do nome de uma pessoa.
//
// São QUATRO, e cada um responde a uma pergunta diferente de quem lê um
// comentário:
//
//   Autor Insigne        "quem escreveu isto publica com a editora"
//   Assinante Insigne    "esta pessoa lê o acervo, não comprou só este livro"
//   Aprovação do Autor   "quem escreveu O LIVRO leu e gostou deste comentário"
//   Selo Insigne         "a editora destacou este comentário"
//
// Ficam num componente só porque a ordem e o espaçamento entre eles importam:
// desenhados solto em cada tela, o mesmo comentário apareceria com os selos em
// ordens diferentes na página do livro e no carrossel da home.
//
// O selo do ADM vem POR ÚLTIMO de propósito. Os dois primeiros dizem quem a
// pessoa É; os dois últimos são julgamentos sobre o TEXTO, e misturá-los no
// meio faria parecer mais um atributo da pessoa.
//
// A APROVAÇÃO DO AUTOR É AZUL (11/09/2026, pedido do dono: "cor diferente do
// selo da editora"). O laranja já é da editora e da Coin, o âmbar é do selo
// de autor, o vermelho é do Ticket e o verde é do desconto — o azul claro da
// família navy era o único tom da paleta que ainda não dizia nada. O coração é
// o gesto que o autor faz para dá-lo, na Área do Autor.
import React from "react";

// Forma, respiro e corpo do texto vêm de `.selo` (App.css) — a mesma classe
// dos selos da página do produto e do leitor. Aqui sobra só a COR, que é o que
// diferencia uma plaquinha da outra. Redesenhar o formato à mão neste arquivo
// faria as três plaquinhas divergirem do resto do site na primeira mudança.
const Plaqueta = ({ icone, texto, classes, titulo }) => (
  <span title={titulo} className={"selo " + classes}>
    <i className={"bi " + icone} />
    {texto}
  </span>
);

const Plaquinhas = ({ autor, assinante, aprovadoAutor, selo, className = "" }) => {
  if (!autor && !assinante && !aprovadoAutor && !selo) return null;

  return (
    <span className={"inline-flex items-center gap-1.5 flex-wrap " + className}>
      {autor && (
        <Plaqueta
          icone="bi-book-half"
          texto="Autor"
          titulo="Publica pela Editora Insigne Acadêmica"
          // Mesmo gradiente do selo de autor do perfil: é a mesma identidade,
          // e duas versões da mesma plaquinha em telas diferentes é como se
          // perde o reconhecimento dela.
          classes="text-ink-fixed bg-gradient-to-r from-[#f0a23b] to-[#d97b1a]"
        />
      )}
      {assinante && (
        <Plaqueta
          icone="bi-stars"
          texto="Assinante"
          titulo="Assinante do Clube Insigne"
          classes="text-insigne-orange border border-insigne-orange/45 bg-insigne-orange/10"
        />
      )}
      {aprovadoAutor && (
        <Plaqueta
          icone="bi-heart-fill"
          texto="Aprovação do Autor"
          titulo="O autor do livro aprovou este comentário"
          classes="text-paper bg-insigne-navy-light"
        />
      )}
      {selo && (
        <Plaqueta
          icone="bi-award-fill"
          texto="Selo Insigne"
          titulo="Comentário destacado pela editora"
          classes="text-ink-fixed bg-insigne-orange"
        />
      )}
    </span>
  );
};

export default Plaquinhas;
